import { InjectionToken } from '@angular/core';

export interface SalesOrderConfig {
  apiUrl: string;
}

/** Creates a document module configuration injection token */
export const SALES_ORDER_CONFIG = new InjectionToken<SalesOrderConfig>('SalesOrderConfig');
